// extracted by mini-css-extract-plugin
export var equalColumn = "_eh-0";